import { IRegion } from '../../../../node/types/region';
import { ITypedReduxAction } from '../../types/redux';

export enum ERegionActionType {
  Changed = 'region/changed',
}

export type TChangedAction = ITypedReduxAction<ERegionActionType.Changed, IRegion | void>;

export type TRegionActions = TChangedAction;
